import { EmojiAdd20Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import { QUICK_REACTIONS } from './constants/quickReactions'
import styles from './index.module.scss'

export default function UserChatBubbleQuickReactions({
  handleReaction,
  reactionPickerAnchorEl,
  setReactionPickerAnchorEl,
  setMoreMenuAnchor,
}) {
  return (
    <>
      {QUICK_REACTIONS.map(({ emoji, label }) => (
        <Tooltip key={emoji} text={label} placement="top">
          <button
            type="button"
            className={styles.floatingReaction}
            aria-label={label}
            onClick={() => handleReaction(emoji)}
          >
            {emoji}
          </button>
        </Tooltip>
      ))}
      <Tooltip text="Add reaction" placement="top">
        <button
          type="button"
          className={styles.floatingIconButton}
          aria-label="Add reaction"
          aria-haspopup="dialog"
          aria-expanded={Boolean(reactionPickerAnchorEl)}
          onClick={(event) => {
            event.stopPropagation()
            setMoreMenuAnchor(null)
            const t = event.currentTarget
            setReactionPickerAnchorEl((prev) => (prev === t ? null : t))
          }}
        >
          <EmojiAdd20Regular aria-hidden />
        </button>
      </Tooltip>
    </>
  )
}
